import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'
import { useAssignmentAccess } from '../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../constants/assignment-permissions'

const EditDatabaseInTestModal = ({
    showEditDatabaseInTestModal,
    setShowEditDatabaseInTestModal,
    updateDatabaseInUnitTest,
}) => {
    const [errorMessage, setErrorMessage] = useState('')
    const { hasAccess: hasEditingPermission } = useAssignmentAccess([Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED])

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return updateDatabaseInUnitTest(token, fields, setErrorMessage)
    }

    return (
        <TestModal
            showModal={showEditDatabaseInTestModal}
            setShowModal={setShowEditDatabaseInTestModal}
            submitTest={handleSubmitTest}
            modalTitle={hasEditingPermission ? 'Update database in test' : 'View database in test'}
            submitButtonText='Update'
            fields={{
                name: true,
                input: true,
                cpuTimeLimit: true,
                memoryLimit: true,
                exactMatch: true,
                ignoreCase: true,
                fixtureFiles: true,
            }}
            readOnly={!hasEditingPermission}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showEditDatabaseInTestModal: unitTests.showEditDatabaseInTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowEditDatabaseInTestModal: value => {
            dispatch(unitTestsActions.setShowEditDatabaseInTestModal(value))
        },
        updateDatabaseInUnitTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.updateDatabaseInUnitTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(EditDatabaseInTestModal)
